import { Util } from "@xt/xtbase";

const { getOrigin } = Util;

export function resolveSocialIconUrl(icon) {
  if (!icon || !`${icon}`.trim()) return undefined;
  const value = `${icon}`.trim();
  if (/^https?:\/\//i.test(value)) return value;

  const path = value.startsWith("/") ? value : `/${value}`;
  if (typeof window !== "undefined") {
    return `${window.location.protocol}//${window.location.host}${path}`;
  }
  return `${getOrigin("www")}${path}`;
}

/** 与 user-center About / Follow us 一致 */
export function resolveSocialLabel(name, t) {
  const trimmed = `${name || ""}`.trim();
  if (!trimmed) return "";
  const lower = trimmed.toLowerCase();
  if (lower.includes("twitter")) {
    const v = t("account.followUsOnTwitter");
    return v && v !== "account.followUsOnTwitter" ? v : "Follow us on Twitter";
  }
  if (lower.includes("telegram")) {
    const v = t("account.joinUsOnTelegram");
    return v && v !== "account.joinUsOnTelegram" ? v : "Join us on Telegram";
  }
  if (lower.includes("linkedin")) {
    const v = t("account.followUsOnLinkedin");
    return v && v !== "account.followUsOnLinkedin" ? v : "Follow us on LinkedIn";
  }
  return trimmed;
}

export function mapSocialMediaRows(list, t) {
  if (!Array.isArray(list)) return [];
  return list
    .map((item) => {
      const href = `${item?.linkUrl || item?.link || ""}`.trim();
      if (!href) return null;
      return {
        key: `social-${item.id}`,
        href,
        label: resolveSocialLabel(item.name, t),
        iconUrl: resolveSocialIconUrl(item.icon),
      };
    })
    .filter(Boolean);
}
